// extracted by mini-css-extract-plugin
export default {"npnExternalLink":"styles_npnExternalLink__s1VMI","moveTop":"styles_moveTop__RLhni"};